import { render, staticRenderFns } from "./OrderDialogCalendar.vue?vue&type=template&id=4df00352&scoped=true&"
import script from "./OrderDialogCalendar.vue?vue&type=script&lang=js&"
export * from "./OrderDialogCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df00352",
  null
  
)

export default component.exports